import { Title } from '@mantine/core';
import { useContext } from 'react';
import { CompanyContext } from '../../contexts/CompanyContext';
import { useOfferImage } from '../../hooks/useOfferImage';

/** The thank-you screen for a business on Referral Rewards: the card, the reward, and one door to the share page. */
export function ThankYouRefer({
  sharePageUrl,
  rewardsOfferImg,
  contactUid,
}: {
  sharePageUrl: string;
  rewardsOfferImg?: string;
  contactUid?: string;
}): JSX.Element {
  const { company } = useContext(CompanyContext);
  const { offerImg } = useOfferImage(contactUid, rewardsOfferImg);
  const companyName = company?.name ?? 'this company';
  const offerEnabled = Boolean(company?.referralOfferEnabled);
  const cardUrl = offerEnabled ? offerImg || company?.offerImgUrl || '' : '';

  return (
    <div className="centered-stack">
      {cardUrl && (
        <div className="logo-wrapper offer-image-wrapper">
          <img className="logo-img offer-image" alt="The offer your friends receive" src={cardUrl} />
        </div>
      )}
      <Title className="header-text share-title" mb={10} mt={10} style={{ textWrap: 'balance' }}>
        {offerEnabled
          ? `Share this offer from ${companyName} with your family & friends`
          : `Refer ${companyName} to your family & friends`}
      </Title>
      {company?.promoterReward && (
        <p className="reward-line">
          {offerEnabled && company.offerTitle ? `Your friends get "${company.offerTitle}". ` : ''}
          You earn <span className="reward-amount">{company.promoterReward}</span> for every friend who becomes a customer.
        </p>
      )}
      <a className="platform-button refer-button" href={sharePageUrl}>
        <p className="button-label">Share with friends</p>
      </a>
    </div>
  );
}
